import {Box, Chip, Typography} from '@mui/material';
import {QuestionStatus} from '@cp/model';
import {env} from '../../config/env';

export interface QuestionStatusCountsProps {
  questionCounts: Record<QuestionStatus, number>;
}

export default function QuestionStatusCounts({questionCounts}: QuestionStatusCountsProps) {
  return (
    <Box sx={{mt: 3}}>
      <Typography variant="h6" sx={{color: '#1B263B', mb: 2}}>
        Question Counts by Status
      </Typography>

      {/* Workflow Statuses */}
      <Box sx={{mb: 3}}>
        <Typography variant="subtitle2" sx={{color: '#1B263B', mb: 1.5, fontWeight: 600}}>
          Workflow Steps
        </Typography>
        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 2}}>
          {env.question.workflow.map((status) => {
            const count = questionCounts[status];
            return (
              <Chip
                key={status}
                label={`${env.question.status[status]?.label}: ${count}`}
                sx={{
                  bgcolor: env.question.status[status]?.color || env.question.unknownStatus.color,
                  color: 'white',
                  fontWeight: 600,
                  minWidth: '120px',
                }}
              />
            );
          })}
        </Box>
      </Box>

      {/* Error Statuses */}
      <Box>
        <Typography variant="subtitle2" sx={{color: '#1B263B', mb: 1.5, fontWeight: 600}}>
          Error States
        </Typography>
        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 2}}>
          {env.question.error.map((status) => {
            const count = questionCounts[status];
            return (
              <Chip
                key={status}
                label={`${env.question.status[status]?.label}: ${count}`}
                sx={{
                  bgcolor: env.question.status[status]?.color || env.question.unknownStatus.color,
                  color: 'white',
                  fontWeight: 600,
                  minWidth: '120px',
                }}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}
